import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import IconAdd from '@/icons/Add.svg';

export const AddValueButton = ({
  label,
  isDisabled,
  onPress,
}: {
  label: string;
  isDisabled: boolean;
  onPress: () => void;
}) => {
  return (
    <Stack row justifyContent="flex-end">
      <Button variant="secondary" size="small" onPress={onPress} disabled={isDisabled}>
        <IconAdd />
        {label}
      </Button>
    </Stack>
  );
};
